export const isNull = value =>
  !value && value !== 0 && value !== false && value !== ''
